import List from './List';
import Detail from './Detail';
import {ReceptacleDialog} from '../Client/Cart/Detail';
import Document from './Document';

const Components = {
    List : List,
    Detail,
    Receptacles : ReceptacleDialog,
    Document
}

export default Components;